<template>
  <div class="app-main-content intelligent-booking">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane :label="$t('SeaExport.HangInTheAir')" name="tabPending" :lazy="true">
          <tab-pending
            ref="tabPending"
            :active-tab-name="activeTabName"
            :source="details.source"
            @showDetails="handleShowDetails"
          />
        </el-tab-pane>
        <el-tab-pane ref="tabFinished" :label="$t('SeaExport.Completed')" name="tabFinished" :lazy="true">
          <tab-finished @showDetails="handleShowDetails" />
        </el-tab-pane>
        <el-tab-pane :label="$t('SeaExport.Dustbin')" name="tabTrash" :lazy="true">
          <tab-trash />
        </el-tab-pane>
      </el-tabs>
    </div>
    <intelligent-booking-result-xhq
      v-if="isXhq"
      :visible="details.visible"
      :details="details.data"
      :source="details.source"
      :jingyu-warehouse="jingyuWarehouse"
      @close="handleCloseDetails"
      @success="handleSaveSuccess"
    />
    <intelligent-booking-result
      v-if="!isXhq"
      :visible="details.visible"
      :details="details.data"
      :source="details.source"
      @close="handleCloseDetails"
      @success="handleSaveSuccess"
    />
  </div>
</template>

<script>
import TabPending from '@/views/cargo/v0/SeaExport/IntelligentBooking/components/TabPending'
import TabFinished from '@/views/cargo/v0/SeaExport/IntelligentBooking/components/TabFinished'
import TabTrash from '@/views/cargo/v0/SeaExport/IntelligentBooking/components/TabTrash'
import IntelligentBookingResult from '@/views/cargo/v0/SeaExport/IntelligentBooking/IntelligentBookingResult'
import IntelligentBookingResultXhq from '@/views/cargo/v0/SeaExport/IntelligentBooking/IntelligentBookingResultXhq'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'IntelligentBooking',
  components: { IntelligentBookingResult, TabTrash, TabFinished, TabPending, IntelligentBookingResultXhq },
  data() {
    return {
      activeTabName: 'tabPending',
      details: {
        data: {},
        visible: false,
        from: '',
        source: 0 // 来源
      },
      smartTrustChannel: '',
      jingyuWarehouse: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.details.source = 0
      if (to.query.source) {
        vm.details.source = to.query.source
      }
    })
  },
  computed: {
    isXhq() {
      return this.smartTrustChannel === 'xhq'
    }
  },
  activated() {
    const params = this.$route.query
    this.details.source = 0
    if (params.source) {
      this.details.source = params.source
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.smartTrustChannel = cache.config.get('SmartTrustChannel')
    this.jingyuWarehouse = Number(cache.config.get('JingyuWarehouse')) === 1
  },
  methods: {
    handleShowDetails(e) {
      this.details.from = e.from
      this.details.data = e.params
      this.details.visible = true
    },
    handleCloseDetails() {
      console.log('handleCloseDetails')
      this.details.visible = false
    },
    handleSaveSuccess() {
      this.details.visible = false
      this.$refs[this.details.from].fetchData()
    }
  }
}
</script>

<style scoped>

</style>
